export default "__VITE_ASSET__CDtw9rE5__"